import { CalendarClock } from "lucide-react";
import { isWithinWindow } from "@opus-dt/shared-types";
import { useLineCalendar } from "@/features/lines/calendar/hooks";
import { useOrgTimezone } from "@/hooks/useOrgTimezone";

// Aviso NÃO-BLOQUEANTE de início fora do expediente da linha. FR: nunca impede o
// agendamento (a linha pode operar hora extra, e o motor/sweep tratam a janela); só sinaliza. Linha
// sem calendário (24/7) ou instante dentro de janela ⇒ nada a mostrar. Timezone da fábrica.
export function OpExpedienteNotice({ lineId, start }: { lineId: string; start?: string }) {
  const { data: calendar } = useLineCalendar(lineId);
  const timezone = useOrgTimezone();
  if (!calendar || !start) return null;
  const at = new Date(start);
  if (Number.isNaN(at.getTime()) || isWithinWindow(calendar, at, timezone)) return null;
  return (
    <p
      role="status"
      className="flex items-center gap-1.5 text-[11px] text-rd-warning-700"
      data-testid="op-off-hours-notice"
    >
      <CalendarClock className="h-3 w-3 shrink-0" />O início planejado cai fora do expediente da
      linha — o agendamento é permitido, mas a produção só começa na próxima janela de operação.
    </p>
  );
}
